import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { API_BASE, getToken } from "../lib/apiClient";

// Backend supports auth via ?auth=<jwt> in addition to Bearer header,
// so we can drop it into <img src> directly.
function photoUrl(path) {
  const t = getToken();
  return `${API_BASE}/files/${path}${t ? `?auth=${encodeURIComponent(t)}` : ""}`;
}

export function PhotoStrip({ paths, testidPrefix = "photo" }) {
  const [openPath, setOpenPath] = useState(null);

  useEffect(() => {
    if (!openPath) return;
    const onKey = (e) => e.key === "Escape" && setOpenPath(null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [openPath]);

  if (!paths?.length) return null;

  return (
    <>
      <div className="flex flex-wrap gap-2 mt-3" data-testid={`${testidPrefix}-strip`}>
        {paths.map((p, i) => (
          <button
            key={p}
            onClick={() => setOpenPath(p)}
            className="border border-cmdBorder hover:border-white overflow-hidden shrink-0 focus:border-white transition-colors"
            data-testid={`${testidPrefix}-thumb-${i}`}
            aria-label={`View photo ${i + 1}`}
          >
            <img
              src={photoUrl(p)}
              alt={`Attachment ${i + 1}`}
              className="h-16 w-16 object-cover block"
              onError={(e) => { e.currentTarget.style.opacity = 0.3; }}
            />
          </button>
        ))}
      </div>

      {openPath && (
        <div
          className="fixed inset-0 z-[80] bg-black/95 flex items-center justify-center p-4"
          onClick={() => setOpenPath(null)}
          data-testid={`${testidPrefix}-lightbox`}
        >
          <img
            src={photoUrl(openPath)}
            alt="Full size"
            className="max-h-full max-w-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            onClick={() => setOpenPath(null)}
            className="absolute top-4 right-4 text-white bg-black/60 border border-cmdBorder hover:border-white rounded-full p-2 transition-colors"
            aria-label="Close preview"
            data-testid={`${testidPrefix}-close`}
          >
            <X className="w-5 h-5" />
          </button>
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-xs text-zinc-400 font-mono-live bg-black/60 px-3 py-1 border border-cmdBorder">
            Click outside or press Esc to close
          </div>
        </div>
      )}
    </>
  );
}

export default PhotoStrip;
